import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { parsePhoneNumberFromString as parseMobile } from 'libphonenumber-js/mobile'
import { Text } from 'components/forms'
import { CardItemList } from 'components/Card'
import { Modal } from 'components/Modal'
import Button from 'components/Button'
import useLocale from 'hooks/useLocale'
import { useField, useFormApi } from 'informed'

const PhoneNumberField = ({ field }) => {
	const { fieldState, fieldApi } = useField({ field })
	const formApi = useFormApi()
	const [t] = useTranslation()

	let countryPhoneCode = useLocale()
	switch (countryPhoneCode) {
		case 'de-ch': countryPhoneCode = '+41 '
			break
		case 'de': countryPhoneCode = '+49 '
			break
		default: countryPhoneCode = ''
	}
	const [showModal, setShowModal] = useState()
	const [addingPhone, setAddingPhone] = useState(countryPhoneCode)
	const [addingPhoneError, setAddingPhoneError] = useState()

	const contactPhones = fieldState.value
	const formattedPhones = Array.isArray(contactPhones)
		? contactPhones.map(phone => {
			const parsedPhone = parseMobile(phone)
			const label = parsedPhone ? parsedPhone.formatInternational() : phone
			return { value: phone, label }
		})
		: []
	const invalidNumErr = useMemo(() => t('validators.valid_phone_number'), [t])

	const handlePhoneChange = e => {
		const val = e.target.value
		setAddingPhone(val)
		let fieldError = ''
		const parsedVal = parseMobile(val)
		const isValid = parsedVal ? parsedVal.isValid() : false
		if(!isValid) {
			fieldError = invalidNumErr
		} else {
			const hasDuplicate = contactPhones.some(phone => phone === parsedVal.number)
			if(hasDuplicate) {
				fieldError = `Phone ${val} is already defined for this cash register.`
			}
		}
		setAddingPhoneError(fieldError)
	}
	const handleAddPhone = () => {
		if(!addingPhone) {
			setAddingPhoneError(invalidNumErr)
			return
		}
		if(!addingPhoneError) {
			const parsedVal = parseMobile(addingPhone)
			const newPhones = [...contactPhones, ...parsedVal ? [parsedVal.number] : []]
			fieldApi.setValue(newPhones)
			setShowModal(false)
			setAddingPhone(countryPhoneCode)
			formApi.submitForm()
		}
	}
	return (
		<>
			<CardItemList
				label={t('options_section.fields.contact_phone_numbers')}
				items={formattedPhones}
				ItemComponent={({ item }) => item.label}
				onAddItem={() => setShowModal(true)}
				onRemoveItem={(item = {}) => {
					const newItems = contactPhones.filter(phone => phone !== item.value)
					fieldApi.setValue(newItems)
					formApi.submitForm()
				}}
				height={72}
				style={{ width: 300 }}
			/>
			{showModal &&
				<Modal unmount={() => setShowModal(false)} label={t('options_section.strings.set_contact_phone_number')}>
					<Text
						noForm
						label={t('options_section.strings.enter_international_phone_number')}
						value={addingPhone}
						onChange={handlePhoneChange}
						error={addingPhoneError} />
					<Button text={t('common.buttons.apply')} onClick={handleAddPhone} />
				</Modal>
			}
		</>
	)
}

export default PhoneNumberField
